
import { Options } from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'
import { SwitchTableItemMixin } from './switch-table-item-mixin'

@Options({
    name: 'd-switch-table-item'
})
export default class DSwitchTableItem extends Mixins(SwitchTableItemMixin) {}
